export enum BackfillStatus {
    PENDING_CUSTOMER_INPUT = 'PENDING_CUSTOMER_INPUT',
    IN_PROGRESS = 'IN_PROGRESS',
    ERROR = 'ERROR',
    COMPLETE = 'COMPLETE',
}
